// extracted by mini-css-extract-plugin
export default {"splash-title":"SpecialtyBox_splash-title__+uB-J","splash-text":"SpecialtyBox_splash-text__u5ZYn"};